import {
    GET_CONFIG_FORM21,   
    GET_DATOS_ANTECEDENTES_JUDICIALES,
    GET_COMBO_COMPETENCIA,
    GET_COMBO_CORTE,
    GET_COMBO_TRIBUNALES,
    GET_COMBO_LIBROS,
    GET_COMBO_HITO_JUDICIAL,
    GET_GRILLA_HISTORIAL_JUDICIAL,
    POST_ACTUALIZAR_JUDICIAL,
    GET_CONFIG_FORM22,
    GET_COMBO_TIPO_GASTO,
    GET_COMBO_COBERTURA,
    GET_COMBO_MONEDAS,
    GET_GRILLA_HISTORIAL_GASTOS,
    POST_ACTUALIZAR_TIPO_GASTO,
    POST_ANULAR,
    SET_LOADING_JUDICIAL,
    SET_LOADING_GASTOS,
    LIMPIAR_REF
    
} from '../types';

export default function procesoJudicialReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM21:
            return { ...state, cfg_form21:action.payload }
        case GET_CONFIG_FORM22:
            return { ...state, cfg_form22:action.payload }
        case GET_DATOS_ANTECEDENTES_JUDICIALES:
            return { ...state, datosAntecedentesJudiciales:action.payload }
        case GET_COMBO_COMPETENCIA:
            return { ...state, comboCompetencia:action.payload }
        case GET_COMBO_CORTE:
            return { ...state, comboCorte:action.payload }
        case GET_COMBO_TRIBUNALES:
            return { ...state, comboTribunales:action.payload }
        case GET_COMBO_LIBROS:
            return { ...state, comboLibros:action.payload }
        case GET_COMBO_HITO_JUDICIAL:
            return { ...state, comboHitoJudicial:action.payload }
        case GET_GRILLA_HISTORIAL_JUDICIAL:
            return { ...state, grillaHistorialJudicial:action.payload }
        case POST_ACTUALIZAR_JUDICIAL:
            return { ...state, respuestaJudicial:action.payload }
        case GET_COMBO_TIPO_GASTO:
            return { ...state, comboTipoGasto:action.payload }
        case GET_COMBO_COBERTURA:
            return { ...state, comboCobertura:action.payload }
        
        case GET_COMBO_MONEDAS:
            return { ...state, comboMonedas:action.payload }
        case GET_GRILLA_HISTORIAL_GASTOS:
            return { ...state, grillaHistorialGastos:action.payload }
        case POST_ACTUALIZAR_TIPO_GASTO:
            return { ...state, respuestaTipoGastos:action.payload }
        case POST_ANULAR:
            return { ...state, respuestaAnular:action.payload }
        case SET_LOADING_JUDICIAL:
            return { ...state, loadingJudicial:action.payload }
        
        case SET_LOADING_GASTOS:
            return { ...state, loadingGastos:action.payload }
        case LIMPIAR_REF:
            return { ...state, cleanRef:action.payload }
        
       
        default:
            return state
    }
}